export const FieldTypes = [
  {
    name: "Boolean",
    _id: 3,
    specification: {
      defaultLayoutId: 5,
      type: "radiobutton",
      values: [{ _id: 5, name: "Checkbox" }],
    },
  },
  {
    name: "Date / DateTime",
    _id: 5,
    specification: {
      type: "radiobutton",
      defaultLayoutId: 7,
      values: [
        { _id: 7, name: "Datetime unrestricted" },
        { _id: 8, name: "Date unrestricted" },
      ],
    },
  },
  {
    name: "Multiselection",
    _id: 6,
    specification: {
      type: "radiobutton",
      defaultLayoutId: 9,
      values: [
        { _id: 9, name: "Dropdown list" },
        { _id: 13, name: "Checkboxes Vertical" },
      ],
    },
    options: [
      {
        name: "Values",
        type: "textbox",
      },
    ],
  },
  {
    name: "Number / Counter",
    _id: 4,
    specification: {
      type: "radiobutton",
      defaultLayoutId: 6,
      values: [{ _id: 6, name: "Number (Textfield)" }],
    },
    options: [{ name: "RegEx", type: "textbox" }],
  },
  {
    name: "Selection",
    _id: 2,
    specification: {
      type: "radiobutton",
      defaultLayoutId: 3,
      values: [
        { _id: 3, name: "Dropdown list" },
        { _id: 4, name: "Radiobuttons Vertical" },
        { _id: 10, name: "Radiobuttons Horizontal" },
      ],
    },
    options: [{ name: "Values", type: "textbox" }],
  },
  {
    name: "Service Link",
    _id: 7,
    specification: {
      type: "radiobutton",
      defaultLayoutId: 11,
      values: [{ _id: 11, name: "Service Link" }],
    },
    options: [
      {
        name: "Service",
        type: "dropdown",
      },
      {
        name: "Form",
        type: "dropdown",
      },
    ],
  },
  {
    name: "Text",
    _id: 1,
    specification: {
      type: "radiobutton",
      defaultLayoutId: 1,
      values: [
        { _id: 1, name: "single Line Text( 1 Line)" },
        { _id: 2, name: "Text Area(3 Lines)" },
      ],
    },
    options: [{ name: "RegEx", type: "textbox" }],
  },
];
